module.exports = __webpack_public_path__ + "img/ground-ground-morning.5b7e90c9.png";